import { axiosInstanceReservation, axiosInstanceApiMyBt, axiosAuthInstance } from "./instance";

export const getQuoteDetail = (id) => {
    return axiosInstanceReservation.get(
        `/quotes/${id}`
    );
};

export const signatureQuote = (data) => {
    return axiosInstanceReservation.post(
        `/quotes/signature-quote/`, data
    );
};

export const infoSelectForm = (data) => {
    return axiosInstanceApiMyBt.get(
        `customForm/info-select`
    );
};

export const updateInfoQuote = (data) => {
    return axiosInstanceApiMyBt.post(
        `customForm/update-info-quote`, data
    );
};

export const searchCustomDataSelect = (data) => {
    return axiosInstanceApiMyBt.post(
        `customForm/search-custom-data-select`, data
    );
};

export const listByCountry = (id) => {
    return axiosAuthInstance.get(
        `listByCountry/${id}`
    );
};

